export const ROUTE_NOT_FOUND = "Not Found";
export const ROUTE_HOME = "Home";
export const ROUTE_DISCLAIMER = "Disclaimer";
// ARTICLES
export const ROUTE_AFFORDABLE_HOUSING = "Affordable Housing";
export const ROUTE_IMPACT_LITIGATION = "Impact Litigation";
export const ROUTE_HEALTHCARE_LITIGATION = "Healthcare Litigation";
export const ROUTE_ENVIRONMENTAL_LAW = "Environmental Law";
export const ROUTE_SPORTS_LAW = "Sports Law";
export const ROUTE_CORPORATE = "Corporate";
export const ROUTE_REAL_ESTATE = "Real Estate";
export const ROUTE_TAX_EXEMPT = "Tax-Exempt Organizations";
export const ROUTE_ENTERTAINMENT = "Entertainment + Film Financing";
export const ROUTE_TAX_CREDIT_FINANCING = "Tax Credit Financing";

export const articleRoutes = [
  {
    label: "Affordable Housing",
    route: ROUTE_AFFORDABLE_HOUSING,
  },
  {
    label: "Impact Litigation",
    route: ROUTE_IMPACT_LITIGATION,
  },
  {
    label: "Healthcare Litigation",
    route: ROUTE_HEALTHCARE_LITIGATION,
  },
  {
    label: "Environmental Law",
    route: ROUTE_ENVIRONMENTAL_LAW,
  },
  {
    label: "Sports Law",
    route: ROUTE_SPORTS_LAW,
  },
  {
    label: "Corporate",
    route: ROUTE_CORPORATE,
  },
  {
    label: "Real Estate",
    route: ROUTE_REAL_ESTATE,
  },
  {
    label: "Tax-Exempt Organizations",
    route: ROUTE_TAX_EXEMPT,
  },
  {
    label: "Entertainment + Film Financing",
    route: ROUTE_ENTERTAINMENT,
  },
  {
    label: "Tax Credit Financing",
    route: ROUTE_TAX_CREDIT_FINANCING,
  },
];
